import { render, staticRenderFns } from "./SpeakerTierEditor.vue?vue&type=template&id=381fe5cf&scoped=true&"
import script from "./SpeakerTierEditor.vue?vue&type=script&lang=ts&"
export * from "./SpeakerTierEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fe5cf",
  null
  
)

export default component.exports